module.exports = __webpack_public_path__ + "img/envelope.257f128d.svg";